import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TPAStage } from '../models/tpa-test-data.modal';

export interface TestInformationDialogData {
  noOfProbes?: number;
  linearResistance?: number;
  effectiveLength?: number;
  effectiveRadius?: number;
  stages: TPAStage[];
}

@Component({
    selector: 'app-test-information-dialog',
    templateUrl: './test-information-dialog.component.html',
    styleUrls: ['./test-information-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TestInformationDialogComponent {
  readonly stageColumns = ['stageNumber', 'powerLevel', 'samplingRate', 'startTime', 'endTime'];

  constructor(
    private dialogRef: MatDialogRef<TestInformationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TestInformationDialogData,
  ) {}

  formatValue(value: number | null | undefined, unit?: string): string {
    if (value === null || value === undefined || !Number.isFinite(value)) return '—';
    return unit ? `${value} ${unit}` : String(value);
  }

  close(): void {
    this.dialogRef.close();
  }
}
